import React from 'react';
import { connect } from 'react-redux';
import { editOrder } from '../../../actions'
import { RaisedButton } from 'material-ui';
import { Formik, Field } from 'formik';
import { TextField } from 'material-ui';
import Snackbar from 'material-ui/Snackbar';

const getCustomer = (disable)=> [{
  label: 'User Id',
  name: 'id',
  disabled: true
}, {
  label: 'Email',
  name: 'customer_email',
  disabled: disable
}, {
  label: 'First Name:',
  name: 'customer_name',
  disabled: disable
}, {
  label: 'Last Name:',
  name: 'customer_last_name',
  disabled: disable
}, {
  label: 'Phone Number',
  name: 'customer_phone',
  disabled: disable
}]

class Customer extends React.Component {
  
  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }
  render() {
    const disable = this.props.disableView || (this.props.isFulfillment || this.props.isCanceled)
    const options = getCustomer(disable)
    const { styles, order, dispatch } = this.props
    const { customerName, customerEmail, customerPhone, customerLastName, userId } = order
    console.log('order in Customer', order)
    const initialValues = {
        id: userId,
        customer_name: customerName || '',
        customer_last_name: customerLastName || '',
        customer_email: customerEmail || '',
        customer_phone: customerPhone || '',
    }
    const hideView = this.props.disableView ? 'none' : 'inline'
    return (
      <div >
        <h2>Customer</h2>
        <div style={{ paddingLeft:'40px', paddingBottom: '20px' }}>
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            onSubmit={(values) => {
              const new_customer =
              {
                customer_last_name: values.customer_last_name,
                customer_name: values.customer_name,
                customer_email: values.customer_email,
                customer_phone: values.customer_phone
              }
              dispatch(editOrder(order.id, new_customer))
                .then((res) => {
                  this.setState({ open: true })
                })
                .catch((err) => { console.log("ERR", err) })
            }}
            render={(props) => (
              <form onSubmit={props.handleSubmit}>
                  <div className="row">
                    {options.map(({ label, name, disabled }) => (
                      <div className="col-md-6 col-lg-4">
                        <Field name={name}>
                          {({ field, form }) => (
                            <div>
                              <TextField
                                {...field}
                                floatingLabelText={label}
                                floatingLabelStyle={styles.floatingLabelStyle}
                                floatingLabelFixed={true}
                                disabled={disabled}
                              />
                              {form.touched[field.name]}
                            </div>
                          )}
                        </Field>
                      </div>
                    ))}
                  </div>
                  <br /><br />
                  <span style={{display: hideView}} >
                    <RaisedButton type='submit' primary tabIndex={-1}> Save </RaisedButton>
                  </span>
              </form>
            )}
          />
        </div>
          <Snackbar
            open={this.state.open}
            message={'Customer Field(s) Edited Successfully!'}
            autoHideDuration={4000}
          />
      </div>
    )
  }
}

export default connect()(Customer);


// WEBPACK FOOTER //
// ./src/components/orders/Common/Customer.js